<ng-template #PDFModal let-modal>
  <div class="modal-header d-block">

    <!-- Barra superior del overlay: botones centrados, cerrar a la derecha -->
    <div style="display: flex; align-items: center; justify-content: center;
                padding: 6px 12px; flex-shrink: 0; position: relative; min-height: 44px;">

    

      <!-- Centro: prev / next (solo cuando hay más de un informe) -->
      <div *ngIf="documents.length > 1"
        style="display: flex; align-items: center; gap: 12px;">
        <button [disabled]="!hasPrev()" (click)="changeDocument(this.documentIndex-1)"
          style="background-color: #f2c63d; color: #101D30; border: none; border-radius: 4px;
                padding: 4px 16px; font-size: 18px; cursor: pointer; line-height: 1;"
          [style.opacity]="hasPrev() ? '1' : '0.3'">
          &lt;
        </button>
        <button [disabled]="!hasNext()" (click)="changeDocument(this.documentIndex+1)"
          style="background-color: #f2c63d; color: #101D30; border: none; border-radius: 4px;
                padding: 4px 16px; font-size: 18px; cursor: pointer; line-height: 1;"
          [style.opacity]="hasNext() ? '1' : '0.3'">
          &gt;
        </button>
      </div>

      <!-- Derecha: cerrar (posición absoluta para no afectar al centrado) -->
      <div style="position: absolute; right: 12px;">
        <button (click)="modal.dismiss('Cross click'); clearVariables();"
          style="background: none; border: none; cursor: pointer; padding: 4px;">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path fill="white" d="M256-213.847 213.847-256l224-224-224-224L256-746.153l224 224 224-224L746.153-704l-224 224 224 224L704-213.847l-224-224-224 224Z"/>
          </svg>
        </button>
      </div>

    </div>

  </div>

  <div class="modal-body" style="height: 90vh; width: 100%;">
    <div style="height: 100%; width: 100%;" *ngIf="reportURL!=null">
      <pdf-viewer class='w-100 h-100 d-block' 
                  [style.position]="'relative'" 
                  [src]="reportURL" [original-size]="false"
        [show-all]="true" [zoom-scale]="'page-fit'" [zoom]="pdfZoom">
      </pdf-viewer>
      <button type="button" class="btn btn-primary"
        style="position: absolute;left: 15px;top: 15px;width: 25px;height: 25px;padding: 0;"
        (click)='pdfZoom=(pdfZoom > 4) ? 4 : pdfZoom+0.1'>
        +
      </button>
      <button type="button" class="btn btn-primary"
        style="position: absolute;left: 15px;top: 45px;width: 25px;height: 25px;padding: 0;"
        (click)='pdfZoom=(pdfZoom <= 0) ? 0 : pdfZoom-0.1'>
        -
      </button>

      <button type="button" class='btn btn-primary'
        style="position: absolute; top: 15px; right: 30px;width: 35px;height: 35px"
        (click)='print()'>
        <span class='prp-icons icon-print' ></span>
      </button>
      <button type="button" class='btn btn-primary'
        style="position: absolute; top: 55px; right: 30px;width: 35px;height: 35px"
        (click)='download()'>
        <span class='visor-icons icon-download'></span>
      </button>
      
    </div>
  </div>

</ng-template>
